import { gateway } from "../../../gateway";
import { IEventDeliveryApiKey } from "../interfaces";

export const getEventDeliveryApiKey = async (): Promise<IEventDeliveryApiKey> => {
  const response = await gateway.get("/event-delivery/config/api-key");
  return response?.data?.data;
};
